export default __webpack_public_path__ + "static/media/249793256707c78f.25bb1ca83107d43d91d91e731a9d4c7b.svg";